import { render, staticRenderFns } from "./SpendingScatter.vue?vue&type=template&id=705b173e"
import script from "./SpendingScatter.vue?vue&type=script&lang=js"
export * from "./SpendingScatter.vue?vue&type=script&lang=js"
import style0 from "./SpendingScatter.vue?vue&type=style&index=0&id=705b173e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports